import { Link } from "office-ui-fabric-react";

const ReportedTimeSynchronizationSettingsTooltip = () => {
    return <span>
        Manage the synchronization of the time reported by users within your PPM Express Tenant. Please
        refer to the <Link
            target="_blank"
            href="https://help.ppm.express/89495-ppm-express-settings/2610325-time-tracking-settings#section-1">
                article 
        </Link> for more details.
    </span>
}

export default ReportedTimeSynchronizationSettingsTooltip;